/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:15:03
 * @LastEditTime: 2021-04-14 16:29:21
 */
// network 网络请求相关
import { setCSRF } from './security';
import loader from './loader';
import { isObject, isFunction, isBoolean, isString, isNumber } from './base';
var xmlRequestId = 0;
var xmlRequestPool = {}; // 请求池

var createXMLRequest = function createXMLRequest() {
  var xhr = null;

  try {
    xhr = new window.XMLHttpRequest();
  } catch (e) {
    xhr = new window.ActiveXObject('Microsoft.XMLHTTP');
  }

  if (xhr) {
    xmlRequestId = xmlRequestId + 1;
    xmlRequestPool[xmlRequestId] = {
      xhr: xhr
    };
  }

  return {
    xmlRequestId: xmlRequestId,
    xhr: xhr
  };
};

var xhrSuccessStatus = {
  // File protocol always yields status code 0, assume 200
  0: 200,
  // Support: IE <=9 only
  // #1450: sometimes IE returns 1223 when it should be 204
  1223: 204
};

var parseAjaxData = function parseAjaxData(response, dataType) {
  var data = null;
  var error = '';

  try {
    if ('text' == dataType) {
      data = response.text;
    } else if ('json' == dataType) {
      data = JSON.parse(response.text);
    }
  } catch (e) {
    error = e;
  }

  return {
    data: data,
    error: error
  };
};

var network = {
  // get方式
  get: function get(url, options) {
    options = options || {};

    if (isObject(url)) {
      options = url;
      url = undefined;
    } else {
      options.url = url;
    }

    options.type = 'GET';
    return this.ajax(options);
  },
  // post方式
  post: function post(url, options) {
    options = options || {};

    if (isObject(url)) {
      options = url;
      url = undefined;
    } else {
      options.url = url;
    }

    options.type = 'POST';
    return this.ajax(options);
  },
  // 获取文本数据
  getText: function getText(url, callback, errorcallback) {
    var options = {
      url: url,
      dataType: 'text',
      success: callback,
      error: errorcallback
    };
    return this.ajax(options);
  },
  // 获取脚本
  getScript: function getScript(url) {
    return loader.loadScript(url);
  },
  // get方式 获取json
  getJSON: function getJSON(url, data, callback) {
    var options = {
      url: url,
      dataType: 'json',
      success: callback
    };
    return this.ajax(options);
  },

  /*
    	options:{
    		url:'',//默认当前页面
    		type/method:'',//发起请求的方式，默认get
    		dataType:'',//返回数据的格式，默认json
    		timeout:0,//超时时间,默认不超时
    		async:true,//是否异步，默认异步
    		data:{},//发送的数据，默认为空
    		headers:{},//待发送的header
    		xhrFields:{}//附加到xhr对象上的属性
    		success/done:function(){},
    		error/fail:function(){},
    		complete:function(){}
    	}
    */
  ajax: function ajax(url, options) {
    var _createXMLRequest = createXMLRequest(),
        xhr = _createXMLRequest.xhr,
        xmlRequestId = _createXMLRequest.xmlRequestId;

    options = options || {};

    if (isObject(url)) {
      options = url;
      url = undefined;
    } else {
      options.url = url;
    } // url


    options.url = options.url || location.href; // type

    options.type = options.type || options.method || 'GET';
    options.type = options.type.toUpperCase(); // dataType

    options.dataType = options.dataType || 'json'; // timeout

    if (!isNumber(options.timeout) || options.timeout < 0) {
      options.timeout = 0;
    } // async


    if (!isBoolean(options.async)) {
      options.async = true;
    } // data


    options.data = options.data || {}; // for (let k in options.data) {
    //     try {
    //         options.data[k] = encodeURIComponent(options.data[k]);
    //     } catch(e) {
    //     }
    // }
    // 判断是否需要csrf

    if (options.csrf) {
      var token = setCSRF();
      options.data.iegmilo_csrftoken = token;
    } // headers


    options.headers = options.headers || {}; // xhrFields

    options.xhrFields = options.xhrFields || {}; // success
    // eslint-disable-next-line no-unused-vars

    options.success = isFunction(options.success) ? options.success : isFunction(options.done) ? options.done : function (data, xhr) {}; // fail

    options.error = isFunction(options.error) ? options.error : isFunction(options.fail) ? options.fail : function (xhr, textStatus, err) {
      throw err;
    }; // complete
    // eslint-disable-next-line no-unused-vars

    options.complete = isFunction(options.complete) ? options.complete : function (status, statusText, xhr) {}; // jsonp请求

    var realUrl = options.url;
    var sendData = null;
    var cbName = 'callback';
    var cbVal = "miloJsonpCb_".concat(Math.ceil(100000 * Math.random()));

    if ('jsonp' == options.dataType) {
      if (options.callback && isString(options.callback)) {
        cbName = options.callback;
      }

      if (options.jsonpCallback && isString(options.jsonpCallback)) {
        cbVal = options.jsonpCallback;
      }

      if (realUrl.indexOf('?') > -1) {
        realUrl += "&".concat(cbName, "=").concat(cbVal);
      } else {
        realUrl += "?".concat(cbName, "=").concat(cbVal);
      } // data


      for (var k in options.data) {
        realUrl += "&".concat(k, "=").concat(options.data[k]);
      }

      window[cbVal] = function (data) {
        // add by weiztang Milo调试系统上报支持
        window.MiloDebug && window.MiloDebug.setJsonp && window.MiloDebug.setJsonp(realUrl, data);
        options.success.call(null, data);
      };

      loader.loadScript({
        url: realUrl,
        timeout: options.timeout
      }).then(function (isLoad) {
        if (!isLoad) {
          options.error.call(null, null, 'timeout', 'timeout');
        }
      });
      return;
    }

    var arrParams = [];

    for (var _k in options.data) {
      arrParams.push("".concat(_k, "=").concat(options.data[_k]));
    }

    if ('GET' == options.type) {
      if (arrParams.length) {
        if (realUrl.indexOf('?') > -1) {
          realUrl += "&".concat(arrParams.join('&'));
        } else {
          realUrl += "?".concat(arrParams.join('&'));
        }
      }
    } else if ('POST' == options.type) {
      if (isObject(options.data)) {
        sendData = arrParams.join('&');
      } else {
        sendData = options.data;
      }
    } // script 请求


    if ('script' == options.dataType) {
      loader.loadScript(realUrl).then(function (isLoad) {
        if (!isLoad) {
          options.error.call(null, null, 'timeout', 'timeout');
        } else {
          options.success.call(null);
          options.complete.call(null, 200, 'OK');
        }
      });
      return;
    } // 打开请求


    xhr.open(options.type, realUrl, options.async); // xhrField

    for (var _k2 in options.xhrFields) {
      xhr[_k2] = options.xhrFields[_k2];
    } // headers


    for (var hName in options.headers) {
      xhr.setRequestHeader(hName, "".concat(options.headers[hName]));
    } // POST


    if ('POST' == options.type) {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    } // eslint-disable-next-line no-unused-vars


    var timeoutTimer = ''; // timeout

    if (options.async && options.timeout > 0) {
      (function (_xhr, _xmlRequestId, _options) {
        timeoutTimer = setTimeout(function () {
          if (_xhr.readyState != 4) {
            _xhr.abort();
            /* _options.complete(_xhr.status,'timeout',_xhr);
                        _options.error(_xhr,'timeout','timeout');*/

          }
        }, _options.timeout);
      })(xhr, xmlRequestId, options);
    } // complete


    var complete = function complete(status, statusText, response, responseHeaders) {
      if (200 == status) {
        if (!response) {
          if (isString(xhr.responseText)) {
            response = {
              text: xhr.responseText
            };
          } else {
            // binary数据暂不支持处理
            response = {
              binary: xhr.response
            };
          }
        }

        if (!responseHeaders) {
          responseHeaders = xhr.getAllResponseHeaders();
        } // 解析数据


        var _parseAjaxData = parseAjaxData(response, options.dataType),
            data = _parseAjaxData.data,
            error = _parseAjaxData.error;

        if (error) {
          options.error(xhr, statusText, error);
        } else {
          options.success(data, xhr);
        }
      } else {
        options.error(xhr, statusText);
      } // 执行complete


      options.complete(status, statusText, xhr);
    }; // callback
    // eslint-disable-next-line no-multi-assign


    var callback = xmlRequestPool[xmlRequestId].callback = function (type) {
      return function () {
        if ('error' == type) {
          if (!isNumber(xhr.status)) {
            complete(0, 'error');
          } else {
            complete(xhr.status, xhr.statusText);
          }
        } else {
          complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, typeof xhr.responseText !== 'string' ? {
            binary: xhr.response
          } : {
            text: xhr.responseText
          }, xhr.getAllResponseHeaders());
        }
      };
    };

    xhr.onload = callback(); // eslint-disable-next-line no-multi-assign

    var errorCallback = xhr.onerror = xhr.ontimeout = callback('error'); // event

    if (xhr.onabort !== undefined) {
      xhr.onabort = errorCallback;
    } else {
      xhr.onreadystatechange = function () {
        if (4 == xhr.readyState) {
          if (callback) {
            errorCallback();
          }
        }
      };
    } // 发送请求


    xhr.send(sendData);
    return xhr;
  }
};
export default network;